export const WIND_TURBINE_GEARBOX_LOCATIONS = `[
  {
    "identifier": "DataPlate",
    "name": "DataPlate",
    "abbreviation": "DataPlate",
    "description": "",
    "inspectionFor": [],
    "isDataPlate": true,
    "rectInStructImage": {
      "top": 0,
      "left": 0,
      "width": 0,
      "height": 0
    },
    "children": []
  },
  {
    "identifier": "HSS",
    "name": "High-Speed Pinion Shaft",
    "abbreviation": "HSS",
    "description": "",
    "inspectionFor": [
      "50% Inspected"
    ],
    "isDataPlate": false,
    "rectInStructImage": {
      "top": 88,
      "left": 71,
      "width": 6,
      "height": 5
    },
    "children": []
  },
  {
    "identifier": "LSS",
    "name": "Low-Speed Gear",
    "abbreviation": "LSS",
    "description": "",
    "inspectionFor": [
      "90% Inspected"
    ],
    "isDataPlate": false,
    "rectInStructImage": {
      "top": 26,
      "left": 65,
      "width": 11,
      "height": 32
    },
    "children": []
  },
  {
    "identifier": "IMSP",
    "name": "Intermediate Pinion Shaft",
    "abbreviation": "IMSP",
    "description": "",
    "inspectionFor": [],
    "isDataPlate": false,
    "rectInStructImage": {
      "top": 18,
      "left": 65,
      "width": 11,
      "height": 9
    },
    "children": []
  },
  {
    "identifier": "IMG",
    "name": "Intermediate Gear",
    "abbreviation": "IMG",
    "description": "",
    "inspectionFor": [],
    "isDataPlate": false,
    "rectInStructImage": {
      "top": 12,
      "left": 59,
      "width": 6,
      "height": 21
    },
    "children": []
  },
  {
    "identifier": "SUN",
    "name": "Sun Pinion",
    "abbreviation": "SUN",
    "description": "",
    "inspectionFor": [],
    "isDataPlate": false,
    "rectInStructImage": {
      "top": 37,
      "left": 33,
      "width": 14,
      "height": 9
    },
    "children": []
  },
  {
    "identifier": "PG",
    "name": "Planetary Gears",
    "abbreviation": "PG",
    "description": "",
    "inspectionFor": [],
    "isDataPlate": false,
    "rectInStructImage": {
      "top": 45,
      "left": 33,
      "width": 14,
      "height": 18
    },
    "children": [
      {
        "identifier": "PG_1",
        "name": "Planetary Gear 1",
        "abbreviation": "1",
        "description": "",
        "inspectionFor": [],
        "isDataPlate": false,
        "rectInStructImage": {
          "top": null,
          "left": null,
          "width": null,
          "height": null
        },
        "children": [],
        "folderName": "06_PG_1"
      },
      {
        "identifier": "PG_2",
        "name": "Planetary Gear 2",
        "abbreviation": "2",
        "description": "",
        "inspectionFor": [],
        "isDataPlate": false,
        "rectInStructImage": {
          "top": null,
          "left": null,
          "width": null,
          "height": null
        },
        "children": [],
        "folderName": "07_PG_2"
      },
      {
        "identifier": "PG_3",
        "name": "Planetary Gear 3",
        "abbreviation": "3",
        "description": "",
        "inspectionFor": [],
        "isDataPlate": false,
        "rectInStructImage": {
          "top": null,
          "left": null,
          "width": null,
          "height": null
        },
        "children": [],
        "folderName": "08_PG_3"
      }
    ]
  },
  {
    "identifier": "RG",
    "name": "Ring Gear",
    "abbreviation": "RG",
    "description": "",
    "inspectionFor": [],
    "isDataPlate": false,
    "rectInStructImage": {
      "top": 23,
      "left": 33,
      "width": 15,
      "height": 43
    },
    "children": []
  },
  {
    "identifier": "HSRS_CRB",
    "name": "High-Speed Rotor Side Cylindrical Roller Bearing",
    "abbreviation": "HSRS_CRB",
    "description": "",
    "inspectionFor": [],
    "isDataPlate": false,
    "rectInStructImage": {
      "top": 85,
      "left": 34,
      "width": 4,
      "height": 2
    },
    "children": []
  },
  {
    "identifier": "HSGS_TRB",
    "name": "High-Speed Gen Side Tapered Roller Bearing",
    "abbreviation": "HSGS_TRB",
    "description": "",
    "inspectionFor": [],
    "isDataPlate": false,
    "rectInStructImage": {
      "top": 86,
      "left": 60,
      "width": 6,
      "height": 2
    },
    "children": []
  },
  {
    "identifier": "IMGS_TRB",
    "name": "Intermediate Gen Side Tapered Roller Bearing",
    "abbreviation": "IMGS_TRB",
    "description": "",
    "inspectionFor": [],
    "isDataPlate": false,
    "rectInStructImage": {
      "top": 25,
      "left": 76,
      "width": 9,
      "height": 3
    },
    "children": []
  },
  {
    "identifier": "IMRS_CRB",
    "name": "Intermediate Rotor Side Cylindrical Roller Bearing",
    "abbreviation": "IMRS_CRB",
    "description": "",
    "inspectionFor": [],
    "isDataPlate": false,
    "rectInStructImage": {
      "top": 18,
      "left": 53,
      "width": 3,
      "height": 3
    },
    "children": []
  },
  {
    "identifier": "LSGS_TRB",
    "name": "Low-Speed Gen Side Tapered Roller Bearing",
    "abbreviation": "LSGS_TRB",
    "description": "",
    "inspectionFor": [],
    "isDataPlate": false,
    "rectInStructImage": {
      "top": 48,
      "left": 76,
      "width": 7,
      "height": 2
    },
    "children": []
  },
  {
    "identifier": "LSRS_CRB",
    "name": "Low-Speed Rotor Side Cylindrical Roller Bearing",
    "abbreviation": "LSRS_CRB",
    "description": "",
    "inspectionFor": [],
    "isDataPlate": false,
    "rectInStructImage": {
      "top": 47,
      "left": 54,
      "width": 4,
      "height": 3
    },
    "children": []
  },
  {
    "identifier": "PB",
    "name": "Planetary Bearings",
    "abbreviation": "PB",
    "description": "",
    "inspectionFor": [],
    "isDataPlate": false,
    "rectInStructImage": {
      "top": 58,
      "left": 33,
      "width": 14,
      "height": 3
    },
    "children": [
      {
        "identifier": "PB_RS1_CRB",
        "name": "Planet Bearing 1 R Side Half Cyl Roller Bearing",
        "abbreviation": "RS1_CRB",
        "description": "",
        "inspectionFor": [],
        "isDataPlate": false,
        "rectInStructImage": {
          "top": null,
          "left": null,
          "width": null,
          "height": null
        },
        "children": [],
        "folderName": "16_PB_RS1_CRB"
      },
      {
        "identifier": "PB_GS1_CRB",
        "name": "Planet Bearing 1 G Side Half Cyl Roller Bearing",
        "abbreviation": "GS1_CRB",
        "description": "",
        "inspectionFor": [],
        "isDataPlate": false,
        "rectInStructImage": {
          "top": null,
          "left": null,
          "width": null,
          "height": null
        },
        "children": [],
        "folderName": "17_PB_GS1_CRB"
      },
      {
        "identifier": "PB_RS2_CRB",
        "name": "Planet Bearing 2 R Side Half Cyl Roller Bearing",
        "abbreviation": "RS2_CRB",
        "description": "",
        "inspectionFor": [],
        "isDataPlate": false,
        "rectInStructImage": {
          "top": null,
          "left": null,
          "width": null,
          "height": null
        },
        "children": [],
        "folderName": "18_PB_RS2_CRB"
      },
      {
        "identifier": "PB_GS2_CRB",
        "name": "Planet Bearing 2 G Side Half Cyl Roller Bearing",
        "abbreviation": "GS2_CRB",
        "description": "",
        "inspectionFor": [],
        "isDataPlate": false,
        "rectInStructImage": {
          "top": null,
          "left": null,
          "width": null,
          "height": null
        },
        "children": [],
        "folderName": "19_PB_GS2_CRB"
      },
      {
        "identifier": "PB_RS3_CRB",
        "name": "Planet Bearing 3 R Side Half Cyl Roller Bearing",
        "abbreviation": "RS3_CRB",
        "description": "",
        "inspectionFor": [],
        "isDataPlate": false,
        "rectInStructImage": {
          "top": null,
          "left": null,
          "width": null,
          "height": null
        },
        "children": [],
        "folderName": "20_PB_RS3_CRB"
      },
      {
        "identifier": "PB_GS3_CRB",
        "name": "Planet Bearing 3 G Side Half Cyl Roller Bearing",
        "abbreviation": "GS3_CRB",
        "description": "",
        "inspectionFor": [],
        "isDataPlate": false,
        "rectInStructImage": {
          "top": null,
          "left": null,
          "width": null,
          "height": null
        },
        "children": [],
        "folderName": "21_PB_GS3_CRB"
      }
    ]
  },
  {
    "identifier": "GSCB_CRB",
    "name": "Gen Side Carrier Bearing Cylindrical Roller",
    "abbreviation": "GSCB_CRB",
    "description": "",
    "inspectionFor": [],
    "isDataPlate": false,
    "rectInStructImage": {
      "top": 50,
      "left": 50,
      "width": 3,
      "height": 2
    },
    "children": []
  },
  {
    "identifier": "RSCB_CRB",
    "name": "Rotor Side Carrier Bearing Cylindrical Roller",
    "abbreviation": "RSCB_CRB",
    "description": "",
    "inspectionFor": [],
    "isDataPlate": false,
    "rectInStructImage": {
      "top": 28,
      "left": 24,
      "width": 3,
      "height": 3
    },
    "children": []
  }
]`;
